import React from 'react';
import styled from 'styled-components';
import { GoBackLink } from '../../ImpactClaims/ActiveSubmission/styles';
import { QuestionnaireTemplateForm } from './QuestionnaireTemplateForm';

const Container = styled.div`
  padding: 32px;
`;

const Title = styled.h1`
  margin-bottom: 24px;
`;

const StyledGoBackLink = styled(GoBackLink)`
  margin-bottom: 24px;
`;

export const CreateQuestionnaireTemplate: React.FC = () => {
  return (
    <Container>
      <StyledGoBackLink to="/questionnaire-templates">
        Back to Questionnaire Templates
      </StyledGoBackLink>
      <Title>Create new questionnaire template</Title>
      <QuestionnaireTemplateForm />
    </Container>
  );
};
